import { ValidationError } from '@booking/lib/errors/apiError'
import type { CustomerFormPayload, CustomerFormFields } from '../types'

export function buildCustomerPayload(
  values: CustomerFormFields,
  locale?: string,
  context?: string,
): CustomerFormPayload {
  let additional = {}
  if (context === 'rock-in-rio') {
    additional = {
      rirTerms: Boolean(values.rirTerms),
    }
  }

  return {
    locale: locale ?? 'en',
    firstName: values.firstName,
    lastName: values.lastName,
    email: values.email,
    emailConfirm: values.emailConfirm,
    phone: values.phone,
    country: values.country,
    vatNumber: values.vatNumber ? values.vatNumber : null,
    acceptCommunication: Boolean(values.acceptCommunication),
    acceptTerms: Boolean(values.acceptTerms),
    acceptSessionTerms: Boolean(values.acceptSessionTerms),
    ...additional,
  }
}

/*export function normalizeCustomerApiErrors(error: unknown): ApiErrorItem[] {
  const maybeAxios = error as { response?: { data?: unknown } }

  if (Array.isArray(maybeAxios?.response?.data)) {
    return maybeAxios.response.data as ApiErrorItem[]
  }

  return [{ conditions: [{ message: GENERIC_API_ERROR }] }]
}*/

export function getCustomerErrorMessages(errors: ValidationError[]): string[] {
  if (!errors.length) return []

  const output: string[] = []
  for (const error of errors) {
    for (const condition of error.conditions ?? []) {
      output.push(condition.message)
    }
  }

  return output
}
